/**
 * ONNX-based monocular depth estimators.
 *
 * Phase 13 of the Spec→Code migration plan. The single-frame depth
 * pass runs at recording-Stop time on a representative frame and
 * feeds the SubjectScaleEstimator to recover absolute scale.
 */

import { DepthAnythingV2, type DepthAnythingOptions, type DepthAnythingTier } from './DepthAnythingV2';

export { DepthAnythingV2 };
export type { DepthAnythingOptions, DepthAnythingTier };

export interface PickDepthEstimatorOpts {
  tier?: 'pc' | 'mobile';
  modelUrl?: string;
}

/** Select the right depth tier for the current device. PC = base,
 *  Mobile = small. */
export function pickDepthEstimator(opts: PickDepthEstimatorOpts = {}): DepthAnythingV2 {
  const tier = opts.tier ?? detectDevice();
  const modelTier: DepthAnythingTier = tier === 'mobile' ? 'small' : 'base';
  return new DepthAnythingV2({ tier: modelTier, modelUrl: opts.modelUrl });
}

function detectDevice(): 'pc' | 'mobile' {
  if (typeof navigator === 'undefined') return 'pc';
  const ua = navigator.userAgent;
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  return isMobile ? 'mobile' : 'pc';
}
